import { createUseStyles } from "react-jss";
import tinycolor from "tinycolor2";

const styles = createUseStyles({
  CheckBoxComp: (props: any) => ({
    ...(props?.customStyles?.CheckBoxComp ?? {}),
  }),
  checkbox: (props: any) => ({
    display: "inline-flex",
    alignItems: "center",
    "& input": { display: "none" },
    "& span": {
      position: "relative",
      display: "inline-block",
      width: 20,
      height: 20,
      marginRight: 8,
      border: `2px solid #bfbfbf`,
      background: tinycolor("#bfbfb").lighten(95).toRgbString(),
      borderRadius: 4,
      transition: "all 0.3s",
      cursor: "pointer",
      fontSize: 16,
      color: "transparent",
      fontWeight: "bold",
      textAlign: "center",
      lineHeight: "20px",
    },
    "& input:checked + span": {
      backgroundColor: "#ff9800",
      borderColor: "#ff9800",
      color: "#fff",
    },
    ...(props?.customStyles?.checkbox ?? {}),
  }),
});
type CheckBoxCompProps = {
  checked: boolean;
  id?: string;
  returnRoute?: boolean;
  selectedId?: any;
  selectedTrain?: any;
  selectedType?: any;
  idName?: string;
  setSelectedId?: (value: any) => void;
  setSelectedTrain?: (value: any) => void;
  setSelectedType?: (value: any) => void;
  setChecked: (value: boolean) => void;
};
function CheckBoxComp({
  checked = false,
  id = "",
  selectedId = {},
  returnRoute = false,
  selectedTrain = {},
  selectedType = {},
  idName = "",
  setChecked,
  setSelectedId,
  setSelectedTrain,
  setSelectedType,
}: CheckBoxCompProps) {
  const classes = styles();

  function onChangeHandle() {
    if (!setSelectedId) {
      setChecked(!checked);
      return;
    }
    if (id === selectedId["goTrainId"]) {
      setSelectedId({ ...selectedId, goTrainId: "" });
      if (typeof setSelectedTrain === "function")
        setSelectedTrain({ ...selectedTrain, goRoute: "" });
      if (typeof setSelectedType === "function")
        setSelectedType({ ...selectedType, goRoute: "" });
    } else if (id === selectedId["returnTrainId"]) {
      setSelectedId({ ...selectedId, returnTrainId: "" });
      if (typeof setSelectedTrain === "function")
        setSelectedTrain({ ...selectedTrain, returnRoute: "" });
      if (typeof setSelectedType === "function")
        setSelectedType({ ...selectedType, returnRoute: "" });
    } else if (returnRoute) {
      setSelectedId({ ...selectedId, returnTrainId: id });
    } else if (!returnRoute) {
      setSelectedId({ ...selectedId, goTrainId: id });
    }
  }

  return (
    <div className={classes.CheckBoxComp} id={idName}>
      <label className={classes.checkbox}>
        <input type="checkbox" checked={checked} onChange={onChangeHandle} />
        <span>✓</span>
      </label>
    </div>
  );
}
export default CheckBoxComp;
